import Lenis from '@studio-freight/lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
    init() {
        // Vérifie si l'appareil supporte le hover
        const hasHover = window.matchMedia('(hover: hover)').matches;

        if (!hasHover) return;

        // Initialise Lenis
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            smooth: true,
            mouseMultiplier: 1,
            smoothTouch: false,
            touchMultiplier: 2,
            infinite: false,
        });

        // Initialise GSAP et ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);

        // Synchronise Lenis avec ScrollTrigger
        lenis.on('scroll', ScrollTrigger.update);

        // Rafraîchit ScrollTrigger lors de chaque frame via le ticker GSAP
        // C'est la méthode recommandée pour l'intégration avec Lenis
        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        });

        // Désactive le rafraîchissement natif de GSAP
        gsap.ticker.lagSmoothing(0);

        // Supprimer la boucle raf redondante ci-dessous
        /*
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);
        */
    }
}